import { Modal } from 'components'
import { css, styles } from 'helpers'
import React, { Component } from 'react'
import { Space } from 'webbook-airways'

class Saver extends Component {
  render() {
    const { children, isOpen } = this.props

    if (!isOpen) {
      return null
    }
    return (
      <React.Fragment>
        <Space size={60} />
        <Modal modalRoot={document.getElementById('saver')}>
          <div
            className={css({
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
              boxSizing: 'border-box',
              paddingRight: 20,
              position: 'fixed',
              left: 0,
              bottom: 0,
              height: 60,
              width: '100%',
              backgroundColor: '#fff',
              boxShadow:
                'rgba(50, 50, 93, 0.2) 0px 0px 20px, rgba(0, 0, 0, 0.14) 0px 0px 10px',
              ...styles.animations.fadeInUp
            })}
          >
            {children}
          </div>
        </Modal>
      </React.Fragment>
    )
  }
}

export default Saver
